import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import ProjectDetails from '../ProjectDetails/ProjectDetails';
import { objToArr } from '../../../helpers';
import Styles from './ProjectPreview.styles';

const ProjectPreview = (props) => {
  let details = null;

  const getProjectsFirstImage = (project) => {
    const { scenes = null } = project || {};
    if (scenes) {
      const arrScenes = objToArr(scenes);
      if (arrScenes && arrScenes.length > 0) {
        const { panorama } = arrScenes[0];
        return panorama;
      }
    }
    return null;
  };

  if (props.selectedProjects.length > 1) {
    details = (
      <div style={Styles.centeredInfoText}>Selected {props.selectedProjects.length} projects </div>
    );
  } else if (props.selectedProjects.length === 1) {
    const image = getProjectsFirstImage(props.selectedProject);
    details = (
      <ProjectDetails
        {...props.selectedProject}
        image={image}
        history={props.history}
        auth={props.auth}
      />
    );
  } else {
    details = <div style={Styles.centeredInfoText}>Please select a project</div>;
  }

  return <div style={Styles.previewContainer}>{details}</div>;
};

ProjectPreview.propTypes = {
  selectedProjects: PropTypes.arrayOf(Object).isRequired,
  history: PropTypes.arrayOf(Object),
  selectedProject: PropTypes.shape(),
};

ProjectPreview.defaultProps = {
  selectedProject: {},
  history: [],
};

export default Radium(ProjectPreview);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectPreview/ProjectPreview.js